import React from 'react'
import _ from 'lodash'

var fontWeightMap = {0: 400, 1: 500, 2: 700, 3: 900}
var color2css = c => {
  return c && `rgba(${c.r}, ${c.g}, ${c.b}, ${c.a})`
}

class Custom extends React.Component {
  constructor(props) {
    super(props)
    this.data = props.data.contentData
    this.items = _.map(this.data, d => d.gist)
    this.state = { increment: 0 }
  }

  render() {
    var views = _.get(this.props, 'layout.settings.views')
    return (
      <div className="cusotm-module">
        <div className="stage" style={ this.getStageStyle() }>
          { _.map(views, view => this.getView(view)) }
        </div>
      </div>
    )
  }

  componentDidMount() {
    window.addEventListener('resize', this.refresh)
  }

  componentWillUnmount () {
      window.removeEventListener('resize', this.refresh);
  }

  refresh = () => {
    this.forceUpdate()
  }

  getStageStyle = () => {
    var stage = _.get(this.props, 'layout.settings.stage')
    
    if (this.viewport === 'mobile')
      stage = _.extend({}, stage, stage.mobile)

    return {
      position: 'relative',
      height: stage.height + 'px',
      margin: 'auto',
      backgroundColor: color2css(stage.bgColor),
      backgroundImage: stage.bgImage ? `url(${ stage.bgImage })` : '',
      backgroundPosition: stage.bgPosition,
      backgroundSize: stage.bgSize,
      backgroundRepeat: stage.bgRepeat,
    }
  }

  getView(view) {
    var props = {
      key: view.id,
      style:  this.getViewStyle(view),
      onClick: e => this.onViewClick(e, view),
    }

    if (view.clickKey === 'new-url' || view.clickKey === 'new-tab-url') {
      props.href = view.clickValue
      if (view.clickKey === 'new-tab-url')
        props.target = '_blank'
      return <a {...props}>{ this.templated(view.content) }</a>
    }

    return (
      <div {...props} >{ this.templated(view.content) }</div>
    )

  }

  getViewStyle(view) {
    if (this.viewport === 'mobile')
      view = _.extend({}, view, view.mobile)
    
    return {
      position: 'absolute',
      display: 'block',
      textDecoration: 'none',
      outline: 'none',
      top: `calc(${view.top.px}px + ${view.top.percent}%)`,
      left:  `calc(${view.left.px}px + ${view.left.percent}%)`,
      width:  `calc(${view.width.px}px + ${view.width.percent}%)`,
      height:  `calc(${view.height.px}px + ${view.height.percent}%)`,
      
      borderRadius: view.borderRadius + 'px',
      borderWidth: view.borderWidth + 'px',
      borderStyle: view.borderColor && view.borderStyle,
      borderColor: color2css(view.borderColor),

      backgroundColor: color2css(view.bgColor),
      backgroundImage: view.bgImage ? `url(${ this.templated(view.bgImage) })` : '',
      backgroundPosition: view.bgPosition,
      backgroundSize: view.bgSize,
      backgroundRepeat: view.bgRepeat,

      fontSize: (view.textSize || '12') + 'px',
      fontWeight: fontWeightMap[view.textWeight],
      textAlign: view.textAlignment,
      color: color2css(view.textColor),
      letterSpacing: view.textSpacing + 'px',
      lineHeight: view.textLineHeight + 'em',
      cursor: view.clickKey ? 'pointer' : '',
      userSelect: view.clickKey ? 'none' : '',

      paddingTop: view.paddingTop + 'px',
      paddingLeft: view.paddingLeft + 'px',
      paddingRight: view.paddingRight + 'px'
    }
  }

  get viewport() {
    return (document.body.clientWidth > 700) ? 'desktop' : 'mobile'
  }

  templated = (t) => {
    var
      regex = /\[\s*i(\d*)\s*\]/gi,
      e = regex.exec(t),
      offset = e && Number(e[1])

    if (offset != null) {
      var index = (this.state.increment + offset + this.items.length) % this.items.length
      t = t.replace(regex, '['+ index + ']')
    }
    
    try {
      return _.template(t)({ items: this.items })
    } catch (e) {
      console.error(e)
      return ''
    }
  }

  onViewClick = (e, view) => {
    var
      key = view.clickKey,
      value = view.clickValue
    
    if (!key) return

    if (key === 'increment') {
      this.setState({ increment: this.state.increment + Number(value) })
    } else if (key === 'appcms-action') {
      var action = ({
        'login': _ => console.log('login')
      })[value]
      if (action) action()
    }
  }
}

export default Custom